import React from 'react'

const MicrophoneIcon = ({ fill = '#8F8F8F', ...props }) => {
  const commonProps = React.useMemo(
    () => ({
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill
    }),
    [fill]
  )

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        {...commonProps}
        d='M12 1.25C9.365 1.25 7.25 3.286 7.25 5.769V12.231C7.25 14.714 9.365 16.75 12 16.75C14.635 16.75 16.75 14.714 16.75 12.231V5.769C16.75 3.286 14.635 1.25 12 1.25ZM12 15.25C10.217 15.25 8.75 13.911 8.75 12.231V5.769C8.75 4.089 10.217 2.75 12 2.75C13.783 2.75 15.25 4.089 15.25 5.769V12.231C15.25 13.911 13.783 15.25 12 15.25Z'
      />
      <path
        {...commonProps}
        d='M12 17.75C8.856 17.75 6.25 15.661 6.25 13V11C6.25 10.586 5.914 10.25 5.5 10.25C5.086 10.25 4.75 10.586 4.75 11V13C4.75 16.415 7.964 19.25 12 19.25C16.036 19.25 19.25 16.415 19.25 13V11C19.25 10.586 18.914 10.25 18.5 10.25C18.086 10.25 17.75 10.586 17.75 11V13C17.75 15.661 15.144 17.75 12 17.75Z'
      />
      <path
        {...commonProps}
        d='M11.25 18.35V21.15C11.25 21.4812 11.586 21.75 12 21.75C12.414 21.75 12.75 21.4812 12.75 21.15V18.35C12.75 18.0188 12.414 17.75 12 17.75C11.586 17.75 11.25 18.0188 11.25 18.35Z'
      />
      <path
        {...commonProps}
        d='M15 20.25H9C8.586 20.25 8.25 20.586 8.25 21C8.25 21.414 8.586 21.75 9 21.75H15C15.414 21.75 15.75 21.414 15.75 21C15.75 20.586 15.414 20.25 15 20.25Z'
      />
      <path
        {...commonProps}
        d='M16 5.25H14C13.586 5.25 13.25 5.586 13.25 6C13.25 6.414 13.586 6.75 14 6.75H16C16.414 6.75 16.75 6.414 16.75 6C16.75 5.586 16.414 5.25 16 5.25Z'
      />
      <path
        {...commonProps}
        d='M10 5.25H8C7.586 5.25 7.25 5.586 7.25 6C7.25 6.414 7.586 6.75 8 6.75H10C10.414 6.75 10.75 6.414 10.75 6C10.75 5.586 10.414 5.25 10 5.25Z'
      />
      <path
        {...commonProps}
        d='M16 8.25H14C13.586 8.25 13.25 8.586 13.25 9C13.25 9.414 13.586 9.75 14 9.75H16C16.414 9.75 16.75 9.414 16.75 9C16.75 8.586 16.414 8.25 16 8.25Z'
      />
      <path
        {...commonProps}
        d='M10 8.25H8C7.586 8.25 7.25 8.586 7.25 9C7.25 9.414 7.586 9.75 8 9.75H10C10.414 9.75 10.75 9.414 10.75 9C10.75 8.586 10.414 8.25 10 8.25Z'
      />
      <path
        {...commonProps}
        d='M16 11.25H14C13.586 11.25 13.25 11.586 13.25 12C13.25 12.414 13.586 12.75 14 12.75H16C16.414 12.75 16.75 12.414 16.75 12C16.75 11.586 16.414 11.25 16 11.25Z'
      />
      <path
        {...commonProps}
        d='M10 11.25H8C7.586 11.25 7.25 11.586 7.25 12C7.25 12.414 7.586 12.75 8 12.75H10C10.414 12.75 10.75 12.414 10.75 12C10.75 11.586 10.414 11.25 10 11.25Z'
      />
    </svg>
  )
}

export default MicrophoneIcon
